module.exports = __webpack_public_path__ + "img/27.7300df6a.png";